// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__390fF","buttons":"Footer_buttons__J5HY2"};